import React, {useEffect} from 'react';
import {Container, Grid} from '@mui/material';
import DownloadStoreButton from '../generalPurpose/downloadStoreButton';
import {ApplicationState} from '../../../store';
import {useAppDispatch, useAppSelector} from '../../../store/hooks';
import POCToolSummaryItem from './POCToolSummaryItem';
import {actionCreators} from '../../../store/POCToolsWebPortal/POCToolsWebPortalActions';
import Breadcrumb from '../generalPurpose/Breadcrumb';
import GlobalHeader from '../generalPurpose/GlobalHeader';
import {trackPageView} from '../../../Util/firebaseAnalytics';

export default function POCToolSummaries() {
  const dispatch = useAppDispatch();

  let poctoolSummaries =
    useAppSelector(
      (state: ApplicationState) => state.POCToolsWebPortal.poctoolSummaries,
    ) ?? [];

  useEffect(() => {
    document.title = 'Point-Of-Care Tools | ACEP';
    dispatch(actionCreators.getPOCToolSummaries());
    trackPageView('POCTools Screen');
  }, []);

  return (
    <GlobalHeader>
      <div>
        <Container style={styles.titleContainer}>
          <Breadcrumb links={[{name: 'Point-of-Care Tools', url: ''}]} />
          <h1 style={styles.title}>Point-of-Care Tools</h1>
          <p style={styles.description}>
            ACEP&apos;s Point-of-Care tools are transforming care at the
            bedside. We&apos;ve recruited the field&apos;s top experts and
            thought-leaders to develop tools our members can trust and deploy in
            the clinical setting. The evidence-based, clinical content provided
            in these tools ensures that you are providing the best possible care
            to the patients in your emergency department.
          </p>
          <p style={styles.subDescription}>
            <b>
              Get quick access to the mobile version of Point-of-Care tools now.
            </b>
            &nbsp;The ACEP Mobile app with helpful bedside tools provides
            clinical content and tools for EM physicians to utilize while
            providing care in the ED.
          </p>
          <DownloadStoreButton
            downloadURL="https://play.google.com/store/apps/details?id=com.acepmobile"
            store="google"
          />
          <DownloadStoreButton
            downloadURL="https://apps.apple.com/us/app/acep-mobile/id1623855450"
            store="apple"
          />
          <Grid
            container
            spacing={{xs: 1, md: 2}}
            columns={{xs: 4, sm: 8, md: 12}}>
            {[...poctoolSummaries]
              .sort(
                (a, b) =>
                  new Date(b['lastUpdated']).getTime() -
                  new Date(a['lastUpdated']).getTime(),
              )
              .map(item => (
                <POCToolSummaryItem key={item.id} summary={item} />
              ))}
          </Grid>
        </Container>
      </div>
    </GlobalHeader>
  );
}

const styles = {
  titleContainer: {
    paddingTop: 21,
    marginBottom: '5%',
  },
  title: {
    fontSize: 28,
    fontWeight: '600',
    lineHeight: '120%',
  },
  description: {
    fontSize: 18,
    marginTop: 30,
    fontWeight: '400',
    lineHeight: '150%',
  },
  subDescription: {
    fontSize: 18,
    marginTop: 42,
    fontWeight: '400',
    lineHeight: '150%',
  },
};
